import {getTestProps} from '@benchling/js-test-utils';
import {createStyles} from '@mantine/core';
import React from 'react';

import {resolveAgentAttribution} from 'llm/chat-library/AgentAttributionLink';

export interface VersionHistoryOAuthClientAttributionProps {
  oauth2ClientId?: string;
  oauth2ClientName?: string;
  userId: string;
}

const useStyles = createStyles((theme) => ({
  attribution: {
    color: theme.colors.gray[5],
  },
}));

interface OAuthClientAttribution {
  clientId: string;
  clientName: string;
  userId: string;
}

type AttributionResolver = (attribution: OAuthClientAttribution) => React.ReactNode | undefined;

function getAttributionResolvers(): Array<AttributionResolver> {
  return [resolveAgentAttribution];
}

function resolveOAuthClientAttribution(attribution: OAuthClientAttribution): React.ReactNode | undefined {
  for (const resolveAttribution of getAttributionResolvers()) {
    const result = resolveAttribution(attribution);
    if (result !== undefined) {
      return result;
    }
  }
  return undefined;
}

function VersionHistoryOAuthClientAttribution({
  oauth2ClientId,
  oauth2ClientName,
  userId,
}: VersionHistoryOAuthClientAttributionProps): JSX.Element | null {
  const {classes} = useStyles();
  const customAttribution = React.useMemo(
    () =>
      oauth2ClientId == null || oauth2ClientName == null
        ? undefined
        : resolveOAuthClientAttribution({clientId: oauth2ClientId, clientName: oauth2ClientName, userId}),
    [oauth2ClientId, oauth2ClientName, userId]
  );

  if (oauth2ClientName == null) {
    return null;
  }

  return (
    <span
      className={classes.attribution}
      {...getTestProps({component: 'VersionHistoryOAuthClientAttribution', element: 'root'})}
    >
      {' '}
      via {customAttribution === undefined ? oauth2ClientName : customAttribution}
    </span>
  );
}

export default VersionHistoryOAuthClientAttribution;
